// React-free: the catalogue's shape and the availability rule, so the unit
// test (yarn test:bb-pickup) can import them without the Next runtime.

/** Which color + size pairs Best Buy stocks, from the backend catalogue.
 * Global per SKU (not per store or ZIP). `skus` holds ops SKU codes (e.g.
 * "PG08") once `ready`; `variantIds` maps an ops SKU to the Shopify variant
 * (a bare number) of the "Best Buy pickup" product, for the SKUs that have
 * one. The catalogue is cached in sessionStorage and refreshed every
 * BB_CATALOGUE_TTL_MS while a consumer is mounted. */
export type PickupCatalogueState = {
  status: 'idle' | 'loading' | 'ready' | 'error';
  skus: ReadonlySet<string> | null;
  variantIds: ReadonlyMap<string, string> | null;
  /** The API's pickup_available is false: pickup is off for everyone, so
   * `skus` is empty. Only meaningful once `ready`. */
  off: boolean;
  /** Epoch ms of the data in `skus` (0 until ready). */
  fetchedAt: number;
};

/** Whether a catalogue state lists this ops SKU as pickup-able: only a ready
 * catalogue with pickup on and the exact SKU in it. Idle, loading, error and
 * "pickup off" all answer false. */
export const catalogueLists = (
  catalogue: PickupCatalogueState,
  opsSku: string,
): boolean =>
  catalogue.status === 'ready' &&
  !catalogue.off &&
  catalogue.skus !== null &&
  catalogue.skus.has(opsSku);
